import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationsModule } from '@ibe.animations/animations.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { StepsModule } from '../steps/steps.module';
import { BookingOptionsModule } from '../options/options.module';
import { ShoppingCartModule } from '../shopping-cart/shopping-cart.module';
import { FlightsPageComponent } from './flights-page/flights-page.component';
// import { TAPFlightsPageComponent } from './flights-page/flights-page.tap.component';
import { FlightResultComponent } from './flight-result/flight-result.component';
// import { TAPFlightResultComponent } from './flight-result/flight-result.tap.component';
import { BrandComponent } from './brand/brand.component';
// import { TAPBrandComponent } from './brand/brand.tap.component';
import { FlightCheckInComponent } from './flight-check-in/flight-check-in.component';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { FlightOptionToolsComponent } from './flight-option-tools/flight-option-tools.component';
// import { TAPFlightOptionToolsComponent } from './flight-option-tools/flight-option-tools.tap.component';
import { ErrorPageModule } from './../error-page/error-page.module';
// import { FlightResultMulticityComponent } from './flight-result-multicity/flight-result-multicity.component';
import { BookAwardFlightsModuleModule } from '../book-award-flights/book-award-flights-module.module';
// import { FlightResultStopoverComponent } from './flight-result-stopover/flight-result-stopover.component';
// import { FlightResultPackComponent } from './flight-result-pack/flight-result-pack.component';
import { ConfirmDialogModule } from '@ibe.components/common/confirm-dialog/confirm-dialog.module';
import { ExtrasFlightModule } from '../extras/extras-flight/extras-flight.module';
import { UpsellEconomyxtraComponent } from './upsell-economyxtra/upsell-economyxtra.component';
// import { TAPUpsellEconomyxtraComponent } from './upsell-economyxtra/TAP-upsell-economyxtra.component';
// import { FlightResultCollapseComponent } from './flight-result-collapse/flight-result-collapse.component';
import { VoucherPromocodeInfoComponent } from '../voucher-promocode-info/voucher-promocode-info.component';
// import { TAPVoucherPromocodeInfoComponent } from '../voucher-promocode-info/voucher-promocode-info.tap.component';
import { INDRAVoucherPromocodeInfoComponent } from '../voucher-promocode-info/voucher-promocode-info.indra.component';
import { TAPPageHighlightBannerComponent } from './page-highlight-banner/page-highlight-banner.tap.component';
import { PageHighlightBannerComponent } from './page-highlight-banner/page-highlight-banner.component';
import { TAPHighlightBannerContentComponent } from './highlight-banner-content/highlight-banner-content.tap.component';
import { HighlightBannerContentComponent } from './highlight-banner-content/highlight-banner-content.component';

/* REPLICATED FILES */
import { INDRAFlightOptionToolsComponent } from './flight-option-tools/flight-option-tools.indra.component';
import { INDRAFlightsPageComponent } from './flights-page/flights-page.indra.component';
import { INDRAFlightResultComponent } from './flight-result/flight-result.indra.component';
import { INDRAFlightResultMulticityComponent } from './flight-result-multicity/flight-result-multicity.indra.component';
import { INDRABrandComponent } from './brand/brand.indra.component';
import { INDRAUpsellEconomyxtraComponent } from './upsell-economyxtra/TAP-upsell-economyxtra.indra.component';
import { INDRAFlightResultPackComponent } from './flight-result-pack/flight-result-pack.indra.component';
import { INDRAFlightResultCollapseComponent } from './flight-result-collapse/flight-result-collapse.indra.component';
import { INDRAFlightResultStopoverComponent } from './flight-result-stopover/flight-result-stopover.indra.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DatesModule } from '../dates/dates.module';

@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		AnimationsModule,
		SharedModule,
		StepsModule,
		BookingOptionsModule,
		ShoppingCartModule,
		BookAwardFlightsModuleModule,
		ErrorPageModule,
		ConfirmDialogModule,
		ExtrasFlightModule,
		InfiniteScrollModule,
		DatesModule
	],
	declarations: [
		FlightsPageComponent,
		// TAPFlightsPageComponent,
		INDRAFlightsPageComponent,
		FlightResultComponent,
		// TAPFlightResultComponent,
		INDRAFlightResultComponent,
		FlightCheckInComponent,
		BrandComponent,
		// TAPBrandComponent,
		INDRABrandComponent,
		FlightOptionToolsComponent,
		// TAPFlightOptionToolsComponent,
		INDRAFlightOptionToolsComponent,
		// FlightResultMulticityComponent,
		INDRAFlightResultMulticityComponent,
		// FlightResultStopoverComponent,
		INDRAFlightResultStopoverComponent,
		// FlightResultPackComponent,
		INDRAFlightResultPackComponent,
		UpsellEconomyxtraComponent,
		// TAPUpsellEconomyxtraComponent
		INDRAUpsellEconomyxtraComponent,
		// FlightResultCollapseComponent,
		INDRAFlightResultCollapseComponent,
		VoucherPromocodeInfoComponent,
		INDRAVoucherPromocodeInfoComponent,
		// TAPVoucherPromocodeInfoComponent,
		PageHighlightBannerComponent,
		TAPPageHighlightBannerComponent,
		HighlightBannerContentComponent,
		TAPHighlightBannerContentComponent
	],
	exports: [
		// TAPFlightResultComponent,
		INDRAFlightResultComponent,
		// TAPBrandComponent
		INDRABrandComponent,
		// TAPVoucherPromocodeInfoComponent
		INDRAVoucherPromocodeInfoComponent
	],
})
export class FlightsModule {}
